import { useState } from "react";

export const useOpenModal = () => {
  const [visible, setVisible] = useState(false);

  const onOpen = () => setVisible(true);

  const onClose = () => setVisible(false);
  return { visible, setVisible, onOpen, onClose };
};
